import { CrudViewFormItemType } from '@rappider/rappider-components/utils';

export const TextAreaConfig = {
  uiDataSelector: CrudViewFormItemType.TextArea,
  settings: {
    minRows: 4
  }
};
